// JsFromRoutes CacheKey 3865ba51f47eaf4984b6261d15235a98
//
// DO NOT MODIFY: This file was automatically generated by JsFromRoutes.
import { definePathHelper } from '@js-from-routes/client'

export default {
  destroy: /* #__PURE__ */ definePathHelper('delete', '/god-mode/stop-impersonating'),
}
